import { render, staticRenderFns } from "./RadioQuestion.vue?vue&type=template&id=2a51f980"
import script from "./RadioQuestion.vue?vue&type=script&lang=js"
export * from "./RadioQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports